import { render, staticRenderFns } from "./ContentCreator.vue?vue&type=template&id=188567a0&scoped=true&"
import script from "./ContentCreator.vue?vue&type=script&lang=js&"
export * from "./ContentCreator.vue?vue&type=script&lang=js&"
import style0 from "./ContentCreator.vue?vue&type=style&index=0&id=188567a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188567a0",
  null
  
)

export default component.exports